import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/services/auth/auth.guard';
import { ThanksGuard } from 'src/app/guards/thanks.guard';
import { CheckoutGuard } from 'src/app/guards/checkout.guard';

export const full_routes: Routes = [

  {
    path: 'wholesales',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('../home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'product',
        loadChildren: () => import('../detail/detail.module').then(m => m.DetailModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('../profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: '',
        loadChildren: () => import('../categories/categories.module').then(m => m.CategoriesModule)
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('../home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'turnos',
    loadChildren: () => import('../turnos/turnos.module').then(m => m.TurnosModule)
  },
  {

    
    path: 'cart',
    children: [
      {
        path: '',
        loadChildren: () => import('../cart-page/cart-page.module').then(m => m.CartPageModule),
      },
      {
        path: ':id',
        loadChildren: () => import('../cart-page/cart-page.module').then(m => m.CartPageModule),
      }
    ]
    // loadChildren: () => import('../cart-page/cart-page.module').then(m => m.CartPageModule)
    // path: 'cart/:id',
    // loadChildren: () => import('../home/home.module').then(m => m.HomeModule) //ruta previa
  },
  {
    path: 'checkout',//no existia
    canActivate: [CheckoutGuard],
    loadChildren: () => import('../checkoutPage/checkout-page.module').then(m => m.CheckoutPageModule)
  },
  {
    path: 'product',
    loadChildren: () => import('../detail/detail.module').then(m => m.DetailModule)
  },
  {
    path: 'faqs',
    loadChildren: () => import('../about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'our-purpose',
    loadChildren: () => import('../about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: 'join-us',
    loadChildren: () => import('../join-us/join-us.module').then(m => m.JoinUsModule)
  },
  {
    path: 'brew-it',
    loadChildren: () => import('../brew-it/brew-it.module').then(m => m.BrewItModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('../contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: 'contact-me',
    loadChildren: () => import('../contact-me/contact-me.module').then(m => m.ContactMeModule)
  },
  {
    path: 'find-us',
    loadChildren: () => import('../points-of-sale/points-of-sale.module').then(m => m.PointsOfSaleModule)
  },
   {
    path: 'my-subscriptions',
    loadChildren: () => import('../my-subscriptions/my-subscriptions.module').then(m => m.MySubscriptionsModule)
  },
  
  {
    path: 'thanks',
    canActivate: [ThanksGuard],
    loadChildren: () => import('../thanks/thanks.module').then(m => m.ThanksModule)
  },
  // {
  //   path: 'politics',
  //   loadChildren: () => import('../politicas/politicas.module').then(m => m.PoliticasModule)
  // },
  // {
  //   path: 'terms',
  //   loadChildren: () => import('../terms/terms.module').then(m => m.TermsModule)
  // },
  // {
  //   path: 'contact',
  //   loadChildren: () => import('../../views-nomenu/contact/contact.module').then(m => m.ContactModule)
  // },
  {
    path: 'search',
    loadChildren: () => import('../searchPage/search-page.module').then(m => m.SearchPageModule)
  },
  {
    path: 'categories',
    loadChildren: () => import('../categories/categories.module').then(m => m.CategoriesModule)
  },
  {
    path: 'all',
    loadChildren: () => import('../allProducts/allProducts.module').then(m => m.AllProductsModule)
  }
]
